import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { ProjectDetailsModal } from './/Modal_ViewProjectDetails';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewProjectListModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewProjects, setViewProjects] = useState([]);

    let [projectID, setProjectID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [showProjectDetailsModal, setShowProjectDetailsModal] = useState(false);

    useEffect(() => {


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_project_list',
                    user: acctID,
                    xStartDateRange: props.startDate.toISOString().substr(0, 10),
                    xEndDateRange: props.endDate.toISOString().substr(0, 10),
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewProjects((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            projectID: cols[0],
                            consultationID: cols[1],
                            customerAccountID: cols[2],
                            estimateID: cols[3],
                            customerFirstName: cols[4],
                            customerLastName: cols[5],
                            customerMobileNumber: cols[6],
                            estimateDescription: cols[7],
                            estimateLatitude: parseFloat(cols[8]).toFixed(2),
                            estimateLongitude: cols[9],
                            dateLogged: cols[10],
                            estimateImage1: cols[11],
                            status: cols[12],
                            externalID: cols[13],
                            start_date: cols[14],
                            end_date: cols[15],
                        })
                    });
                } 
            })

    }, []);

    function deleteProject(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002D');
        formData.append('user', acctID);
        formData.append('xProjectID', ProjectID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002D',
                user: acctID,
                xProjectID: projectID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewProjects([]);
        props.closeModal(event);
    }
 
    function viewProjectDetailsHandler(event) {


        setProjectID(event[1]);
        setShowProjectDetailsModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteProjectHandler(event) {


        //setShowPasswordModal(event[0]);
        setProjectID(event);
    }

    function onSubmitPasswordHandler(event)
    {
        deleteProject(event);
    }



    return (

        <React.Fragment> 
           
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonHeader className='appModalHeader'>
                        <h3> Active Projects </h3>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='1'> <h3> ID </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Estimate Description </h3> </IonCol>*/}
                                    <IonCol size='7'> <h3> Description </h3> </IonCol>
                                    <IonCol size='4'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewProjects.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.estimateID}>
                                         <IonCol size='1'>{detailData.estimateID}</IonCol>
                                        {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='7'>{detailData.estimateDescription}</IonCol>
                                        <IonCol size='4'>

                                            <IonButton className='appListButton' onClick={() => viewProjectDetailsHandler([true, detailData.projectID])}> Details </IonButton>
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteProjectHandler(detailData.projectID)}> Delete </IonButton>}
                                            {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                    
                                        </IonCol>


                                    {showProjectDetailsModal == true && <ProjectDetailsModal openModal={ showProjectDetailsModal } closeModal={() => setShowProjectDetailsModal(false)} data={{
                                                        projectID: detailData.projectID, 
                                                        customerAccountID: detailData.customerAccountID, 
                                                        consultationID: detailData.consultationID, 
                                                        externalID: detailData.externalID,
                                                        userStatus: "member",
                                                        }}></ProjectDetailsModal>}
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>

                    </IonContent>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            </div>
            ) : null }

        </React.Fragment>

    )
}